var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"d-highlight-text"},_vm._l((_vm.textParts),function(part,idx){return _c('span',{key:idx},[(part.isHighlighted)?_c('mark',[_vm._v(_vm._s(part.text))]):_c('span',[_vm._v(_vm._s(part.text))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }